import $ from 'jquery';
import './shared/cookieHelper.js';
import './program/slider.min.js';
import { setCookie, getCookie } from './shared/cookieHelper';

window.GinitMap = function () {
    var map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 50.064192, lng: -130.605469 },
        zoom: 3
    });
    var card = document.getElementById('pac-card');
    var input = document.getElementById('pac-input');
    var countries = 'us';

    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    var autocomplete = new google.maps.places.Autocomplete(input);

    // Set initial restrict to the greater list of countries.
    autocomplete.setComponentRestrictions(
        { 'country': ['us'] });

    // Specify only the data fields that are needed.
    autocomplete.setFields(
        ['address_components', 'geometry', 'icon', 'name']);

    var infowindow = new google.maps.InfoWindow();
    var infowindowContent = document.getElementById('infowindow-content');
    infowindow.setContent(infowindowContent);

    var iconBase = 'https://res.cloudinary.com/dvbdysuf5/image/upload/v1563789272/MakeItPossible/WebResources/';

    var marker = new google.maps.Marker({
        map: map,
        icon: iconBase + 'marker_map.png',
        anchorPoint: new google.maps.Point(0, -29)

    });

    autocomplete.addListener('place_changed', function () {
        infowindow.close();
        marker.setVisible(false);
        var place = autocomplete.getPlace();
        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }

        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);  // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
        $("#btnConfirmAddress").removeAttr("disabled");
        var address = '';
        if (place.address_components) {
            address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
        }

        infowindowContent.children['place-icon'].src = place.icon;
        infowindowContent.children['place-name'].textContent = place.name;
        infowindowContent.children['place-address'].textContent = address;
        infowindow.open(map, marker);

    });


}


window.enableStep2 = function () {
    $("#form1").hide();
    var id = document.getElementById('pac-input').value;
    var add = encodeURIComponent(id);
    setCookie("Address", add, 1);
   id = id.replace(/ /g, "+");
    var lat;
    var lng;
    var latlng;

    var url = "https://maps.googleapis.com/maps/api/geocode/json?address=" + id + ",&key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E";
    $.getJSON(url, function (data, textStatus) {
        lat = data.results[0].geometry.location.lat;
        lng = data.results[0].geometry.location.lng;
        latlng = lat + ',' + lng;
        var url;
        var query;
        query = latlng
        url = "__id__";

        url = url.replace('__id__', query);
        window.location.href = url;
    });


}


window.HideAllQuestions = function() {
    $("#form2").hide();
    $("#form3").hide();
    $("#notifybox").hide();
    $("#q1").hide();
    $("#notifyboxsuccess").hide();

}
//function setCookie(cname, cvalue, exdays) {
//    var d = new Date();
//    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//    var expires = "expires=" + d.toUTCString();
//    document.cookie = cname + "=" + cvalue + ";path=/";
//}

//function getCookie(cname) {
//    var name = cname + "=";
//    var ca = document.cookie.split(';');
//    for (var i = 0; i < ca.length; i++) {
//        var c = ca[i];
//        while (c.charAt(0) == ' ') {
//            c = c.substring(1);
//        }
//        if (c.indexOf(name) == 0) {
//            return c.substring(name.length, c.length);
//        }
//    }
//    return "";
//}

window.showQ1 = function() {
    var result = $("#hdnselectedOption").val();

    if (result == 'aboveplus' || result == 'above') {
        showResult();
    }
    else {
        $("#form2").hide();
        $("#form3").hide();
        $("#result").hide();
        $("#q1").show();
    }
}


window.showResult = function() {
    $("#form2").hide();
    $("#form3").hide();
    $("#q1").hide();
    $("#result").show();



    var result = $("#hdnselectedOption").val();

    if (result == 'under') {
        HideAllQuestions();
        $("#answer").text('Congratulations!');
        $("#additionaltext").text('You qualify for the Freddie Mac HomePossible Grant!');
        var a = parseInt($('#hdnUnderAmt').val()).toLocaleString();
        $("#contacttext").html('Based on the information you’ve provided, you should qualify for <span class="highlight-text">$'+a+'</span> toward downpayment or closing costs.');
        $("#notifybox").hide();
        $("#notifyboxSuccess").show();
        $("#cert-text").html('Click the button below to start your mortgage pre-approval. Once we receive your application, we’ll match you to a local Mortgage Loan Officer, who will guide you through the process. ');

        $.ajax({
            url: "/borrowsmart/UnderAMI",
            //url: "/Marketing/UnderAMI",
            type: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
                //alert(response);
            }
        });

    }
    if (result == 'between') {
        HideAllQuestions();
        $("#answer").text('Congratulations!');
        $("#additionaltext").text('You qualify for the Freddie Mac BorrowSmart Program!');
        var a = parseInt($('#hdnBetweenAmt').val()).toLocaleString();
        $("#contacttext").html('Based on the information you’ve provided, you should qualify for <span class="highlight-text">$'+a+'</span> toward downpayment or closing costs.');
        $("#notifybox").hide();
        $("#notifyboxSuccess").show();
        $("#cert-text").html('Click the button below to start your mortgage pre-approval. Once we receive your application, we’ll match you to a local Mortgage Loan Officer, who will guide you through the BorrowSmart process. ');

        $.ajax({
            url: "/borrowsmart/BetweenAMI",
            //url: "/Marketing/BetweenAMI",
            type: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
                //alert(response);
            }
        });

    }
    if (result == 'above') {
       
        HideAllQuestions();
        $("#answer").html('Sorry, you do not <br/>qualify for this program');
        $("#additionaltext").text('But it might be still possible!');
        $("#contacttext").html('We’re sorry, it looks like you may not qualify for this program based on your combined household income, down payment amount and where you are looking to buy.  However, there could be other special conditions that apply to your situation where this program is still possible.<br/><br/> <span class="highlight-text">To investigate further, please take one of the following steps.</span>');
        $("#notifybox").show();
        $("#notifyboxSuccess").hide();
        $.ajax({
            url: "/borrowsmart/AboveAMI",
            //url: "/Marketing/OverAMI",
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
                //alert(response);
            }
        });
    }
    if (result == 'aboveplus') {

        HideAllQuestions();
        $("#answer").html('Sorry, you do not <br/>qualify for this program');
        $("#additionaltext").text('But it might be still possible!');
        $("#contacttext").html('We’re sorry, it looks like you may not qualify for this program based on your combined household income, down payment amount and where you are looking to buy.  However, there could be other special conditions that apply to your situation where this program is still possible.<br/><br/> <span class="highlight-text">To investigate further, please take one of the following steps.</span>');
        $("#notifybox").show();
        $("#notifyboxSuccess").hide();
        $.ajax({
            url: "/borrowsmart/OverAMI",
            //url: "/Marketing/OverAMI",
            type: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
                //alert(response);
            }
        });

    }

}

window.yesForm3 =function() {
    HideAllQuestions();
    $("#answer").text('Congratulations!');
    $("#additionaltext").text('You qualify for the Freddie Mac BorrowSmart Program!');
    var a = parseInt($('#hdnAboveAmt').val()).toLocaleString();
    $("#contacttext").html('Based on the information you’ve provided, you should qualify for <span class="highlight-text">$'+a+'</span> toward downpayment or closing costs.');
    $("#notifybox").hide();
    $("#notifyboxSuccess").show();
    $("#cert-text").html('Click the button below to  start your mortgage pre-approval. Once we receive your application, we’ll match you to a local Mortgage Loan Officer, who will guide you through the BorrowSmart process. ');

    $.ajax({
        url: "/borrowsmart/AboveAMI",
        //url: "/Marketing/AboveAMI",
        type: 'POST',
        cache: false,
        contentType: false,
        processData: false,
        data: "",
        success: function (response) {
            //alert(response);
        }
    });
}


window.noForm3 =function() {

    HideAllQuestions();
    $("#result").show();
    $("#answer").html('Sorry, you do not <br/>qualify for this program');
    $("#additionaltext").text('But it might be still possible!');
    $("#contacttext").html('We’re sorry, it looks like you may not qualify for this program based on your combined household income, down payment amount and where you are looking to buy.  However, there could be other special conditions that apply to your situation where this program is still possible.<br/><br/> <span class="highlight-text">To investigate further, please take one of the following steps.</span>');
    $("#notifybox").show();
    $("#notifyboxSuccess").hide();
    $.ajax({
        url: "/borrowsmart/AboveAMIHomeNotManufactured",
        //url: "/Marketing/AboveAMIHomeNotManufactured",
        type: 'POST',
        cache: false,
        contentType: false,
        processData: false,
        data: "",
        success: function (response) {
            //alert(response);
        }
    });
}

$(function () {
    if ($('#index_page').length) {      
            $("#form1").show();
            $("#form2").hide();
            $("#result").hide();
            $("#notifybox").hide();
            $("#btnConfirmAddress").attr("disabled", "disabled");     

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAiTYeI5JpL0iYv5WskHudfIQwHKvZVK6E&libraries=places&callback=GinitMap';
        script.async = true;
        document.body.appendChild(script);

    }


    if ($('#program_page').length) {
     
            $("#form2").show();
            $("#form3").hide();
            $("#result").hide();
            $("#notifybox").hide();
        $("#notifyboxSuccess").hide();
        $("#q1").hide();
        $("#successResult").hide();
        $("#submit").attr("disabled", "disabled");
        $("#submit").css("background-color", "#E0E0E0");
            var geocoder;
            var map;
            var address = getCookie("Address");
         
        
        $(document).ready(function () {
            setCookie("VN", "");
            setCookie("VE", "");
            setCookie("VP", "");
            $("#ex14").slider({
                ticks: [0, 1, 2, 3, 4],
                ticks_positions: [0, 25, 50, 75, 100],
                ticks_labels: ['', '', '', '', ''],
                ticks_snap_bounds: 1

            }).on('change', getValue);
        });

    }

    if ($('#coming_soon_page').length) {

        $("#notifyboxSuccess").show();
        $("#successResult").hide();
        $("#signup").attr("disabled", "disabled");
        $("#signup").css("background-color", "#E0E0E0");
        var geocoder;
        var map;
        var address = getCookie("Address");

    }
  

    function getValue() {
            var sliderValue = $("#ex14").val();
            if (sliderValue == 0) {
                $('#hdnselectedOption').val("no");
                $('#hdnGrantAmt').val("0");
                var value = "Please select your income level";
                $('#selectedtext').text(value);
                $("#continue").attr("disabled", "disabled");
                $("#continue").css("background-color", "#92B9D1");
            }
            else {
                $("#continue").removeAttr("disabled");
                $("#continue").css("background-color", "#2775A3");
            }
            if (sliderValue == 1) {
                $('#hdnselectedOption').val("under");
                $('#hdnGrantAmt').val($('#hdnUnderAmt').val());
                var value = "Less than $" + getCookie("amihalf");                
                $('#selectedtext').text(value.replace(/%2C/g, ","));
            }

            if (sliderValue == 2) {
                $('#hdnselectedOption').val("between");
                $('#hdnGrantAmt').val($('#hdnBetweenAmt').val());
                var value = "Between $" + getCookie("amihalf") + " and $" + getCookie("ami");
                $('#selectedtext').text(value.replace(/%2C/g, ","));
            }


            if (sliderValue == 3) {
                $('#hdnselectedOption').val("above");
                $('#hdnGrantAmt').val($('#hdnAboveAmt').val());
                var value = "Between $" + getCookie("ami") + " and  $" + getCookie("amifull");
                $('#selectedtext').text(value.replace(/%2C/g, ","));
            }

            if (sliderValue == 4) {

                $('#hdnselectedOption').val("aboveplus");
                $('#hdnGrantAmt').val($('#hdnAbovePlusAmt').val());
                var value = "Over $" + getCookie("amifull");
                $('#selectedtext').text(value.replace(/%2C/g, ","));
            }
        }

   

    function validateEmail1(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }; 


$('#submit').click(function () {
    var vemail = $("#txtEmail").val();
    if (!validateEmail1(vemail)) {
        $('#txtEmail').focus();
        alert("Invalid Email Address");

    }
    else {
     
        $("#successFormInput").hide();
        $("#successResult").show();
        $("#submit").attr("disabled", "disabled");
        $("#submit").css("background-color", "#E0E0E0");
        $.ajax({
            url: "/borrowsmart/submit",
            //url: "/Marketing/submit",
            type: 'POST',
            cache: false,
            contentType: false,
            processData: false,
            data: "",
            success: function (response) {
                //alert(response);
            }
        });
    }
});


    $('#signup').click(function () {
        var vemail = $("#txtEmail").val();
        if (!validateEmail1(vemail)) {
            $('#txtEmail').focus();
            alert("Invalid Email Address");

        }
        else {

            $("#successFormInput").hide();
            $("#successResult").show();
            $("#signup").attr("disabled", "disabled");
            $("#signup").css("background-color", "#E0E0E0");
            $.ajax({
                url: "/borrowsmart/signup",
                //url: "/Marketing/signup",
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                success: function (response) {
                    //alert(response);
                }
            });
        }
    });


$("#txtName").keyup(
    function () {
        var vname = $("#txtName").val();
        var vemail = $("#txtEmail").val();
        if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
            $("#submit").removeAttr("disabled");
            $("#submit").css("background-color", "#E5B900");
            $("#signup").removeAttr("disabled");
            $("#signup").css("background-color", "#E5B900");
        } else {
            $("#submit").attr("disabled", "disabled");
            $("#submit").css("background-color", "#E0E0E0");
            $("#signup").attr("disabled", "disabled");
            $("#signup").css("background-color", "#E0E0E0");
        }
        setCookie("VN", vname);
    }
);
$("#txtEmail").keyup(
    function () {
        var vname = $("#txtName").val();
        var vemail = $("#txtEmail").val();
        if ((vname.trim() != "" && vname.trim() != "Name*") && (vemail.trim() != "" && vemail.trim() != "Email*")) {
            $("#submit").removeAttr("disabled");
            $("#submit").css("background-color", "#E5B900");
            $("#signup").removeAttr("disabled");
            $("#signup").css("background-color", "#E5B900");

        } else {
            $("#submit").attr("disabled", "disabled");
            $("#submit").css("background-color", "#E0E0E0");
            $("#signup").attr("disabled", "disabled");
            $("#signup").css("background-color", "#E0E0E0");
        }
        setCookie("VE", vemail);
    }
);
$("#txtPhone").keyup(
    function () {
        var vphone = $("#txtPhone").val();
        setCookie("VP", vphone);
    }
);




   
});


